// src/PageA.js

// Assuming the Ballpit component is available in the same directory or correctly imported
import Galaxy from './Galaxy.js'; 

const PageB = () => {
 // Dependency array: Re-run only if 'navigate' changes (it won't, but ESLint likes it)
  return (
    // Outer div creates the full-screen black container, hiding overflow
    <div style={{ width: '100%', height: '100vh', position: 'relative' }}>
    <Galaxy 
        mouseRepulsion={true}
        mouseInteraction={true}
        density={3}
        glowIntensity={.3}
        saturation={2}
        hueShift={140}
        twinkleIntensity={.3}
        repulsionStrength={2}
    />
</div>
  );
};

export default PageB;